<script setup lang="ts"></script>

<template>
  <span class="c-text-regular--xs new-article-tag">新着</span>
</template>

<style scoped lang="scss">
.new-article-tag {
  display: inline-flex;
  align-items: center;
  padding: 0px 8px;
  height: 16px;
  color: $color-orange1000;
  background: #fff;
}
</style>
